<script setup>
import { useSertStore } from '@/stores/sertStore';
import { useValidation } from '@/utils/useValidataion';

const storeSert = useSertStore();

const value = defineModel();

const { validation, isValid, isTouched, textError } = useValidation(value)

defineProps({    
    stateKey: {
        type: String,
    },
    placeholder: {
        type: String,
        default: ''
    },
    responseError: {
        type: Boolean,
        default: false
    },
    responseText: {
        type: String,
        default: ''
    }
})
</script>
<template>
    <label :class="['input']">
        <span class="input__title"><slot></slot></span>
        <input 
            type="tel"
            :placeholder="placeholder"
            :class="['input__field', isTouched && (isValid ? 'valid' : 'not-valid') ]"
            @input="storeSert.updateCheckedItem(stateKey, value), validation(stateKey)"  
            @blur="validation(stateKey)"
            v-model="value"
            v-mask             
        >
        <Transition>
            <span v-if="!!textError" class="input__error">{{ textError }}</span>
        </Transition>
        <Transition>
            <span v-if="responseError" class="input__error">{{ responseText }}</span>
        </Transition>
    </label>
</template>
<style lang='scss' scoped>
.v-enter-active,
.v-leave-active {
  transition: 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}
</style>